import { ReadonlyURLSearchParams } from 'next/navigation';
import qs from 'qs';

import { UserCarsFilterQuery } from '@/types/used-cars/used-cars.types';

export const stringifyQuery = (filtersQuery: UserCarsFilterQuery) => {
  return qs.stringify(filtersQuery);
};

export const parseQuery = (filtersQuery: UserCarsFilterQuery, depth?: any) => {
  return qs.parse(filtersQuery as any, { ...depth, arrayLimit: 100 });
};

export const parseSearchParams = (
  searchParams: ReadonlyURLSearchParams,
  depth?: any,
) => {
  let rawQuery = '';

  searchParams.forEach((value, key) => {
    rawQuery += `${key}=${value}&`;
  });
  return parseQuery(rawQuery as any, depth);
};
